<template>
    <div class="plan-wrapper">
        <div class="content">
            <div class="title">选择您合适的计划</div>
            <div class="main">
                <div class="tab flex-bt">
                    <div class="items" v-for="(item) in tab.list" :key="item.id" @click="tab.active = item.id"
                        :class="[item.id == tab.active ? 'active' : '']">
                        {{ item.name }}
                    </div>
                </div>
                <div class="plan-box flex-center">
                    <div class="items">
                        <div class="top">
                            <div class="name">{{ topList[tab.active].name }}</div>
                            <div class="old-price" v-if="topList[tab.active].oldPrice">
                                {{ topList[tab.active].oldPrice }}
                                <span>{{ topList[tab.active].oldUnit }}</span>
                            </div>
                            <div class="price flex-center" :class="[tab.active == 'year' ? 'active' : '']">{{
                                topList[tab.active].price }}
                                <span>{{ topList[tab.active].unit }}</span>
                            </div>
                            <router-link to="/register">
                                <div class="buy">立即购买</div>
                            </router-link>
                        </div>
                        <div class="list">
                            <div class="small-title">计划尊享内容</div>
                            <div class="child flex-start" v-for="(child, childIndex) in topList[tab.active].list"
                                :key="childIndex">
                                <img src="@/assets/images/advantage.png" class="icon" alt="">
                                {{ child.title }}
                                <span v-if="child.append">{{ child.append }}</span>
                                <div class="sm-tips" v-if="child.tips">
                                    <img src="@/assets/images/info.png" class="" alt="">
                                    <p>{{ child.tips }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="items active">
                        <div class="top-title">星级专享．全港首创！</div>
                        <div class="top-name">企业计划</div>
                        <div class="top-tips">我们可按你的业务需求，为你度身订造解决方案，助你销售爆单！</div>
                        <router-link to="/register">
                            <div class="buy active">立即联络</div>
                        </router-link>
                        <div class="padding-4">
                            <div class="list">
                                <div class="small-title">包括所有爆单电商计划 +</div>
                                <div class="child flex-start active"
                                    v-for="(child, childIndex) in topList[tab.active].rightList" :key="childIndex">
                                    <img src="@/assets/images/advantage.png" class="icon" alt="">
                                    {{ child.title }}
                                </div>

                            </div>
                        </div>
                        <img class="bottom-img" src="@/assets/images/Frame626182.png" alt="">

                    </div>
                </div>
                <div class="icon-list flex-bt">
                    <div class="left flex-start">
                        <img src="@/assets/images/advantage.png" class="icon" alt="">
                        <div class="text">
                            <p class="name"><span>*</span>收款方式</p>
                            <p class="sm-tip">(每项交易会抽取 2.9%手续费)</p>
                        </div>
                    </div>
                    <div class="right flex-start">
                        <img src="@/assets/images/pay-1.png" alt="">
                        <img src="@/assets/images/pay-2.png" alt="">
                        <img src="@/assets/images/pay-3.png" alt="">
                        <img src="@/assets/images/pay-4.png" alt="">
                        <img src="@/assets/images/pay-5.png" alt="">
                        <img src="@/assets/images/pay-6.png" alt="">
                        <img src="@/assets/images/pay-7.png" alt="">
                        <img src="@/assets/images/pay-8.png" alt="">
                        <img src="@/assets/images/pay-9.png" alt="">
                        <img src="@/assets/images/pay-10.png" alt="">
                        <img src="@/assets/images/pay-11.png" alt="">
                        <img src="@/assets/images/pay-12.png" alt="">
                    </div>
                </div>

                <!-- <div class="plan-list flex-bt">
                    <div class="items" v-for="(item, index) in list[tab.active]" :key="index">
                        <div class="top">最受欢迎！</div>
                        <div class="name">{{ item.name }}</div>
                        <div class="old-price" v-if="item.oldPrice">
                            {{ item.oldPrice }}
                        </div>
                        <div class="price flex-center">{{ item.price }} <span>/年</span> </div>
                        <router-link to="/register">
                            <div class="buy">立即购买</div>
                        </router-link>
                        <div class="list">
                            <div class="small-title">计划尊享内容</div>
                            <div class="child flex-start" v-for="(child, childIndex) in item.list" :key="childIndex">
                                <img src="@/assets/images/advantage.png" class="icon" alt="">
                                {{ child.title }}
                            </div>
                        </div>
                        <div class="list none" v-if="item.moreList">
                            <div class="small-title">+精选电商计划</div>
                            <div class="child flex-start" v-for="(child, childIndex) in item.moreList" :key="childIndex">
                                <img src="@/assets/images/advantage.png" class="icon" alt="">
                                {{ child.title }}
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <!-- <div class="price-content">
            <div class="tab flex-bt">
                <div class="items" v-for="(item) in tab.list" :key="item.id" @click="tab.active = item.id"
                    :class="[item.id == tab.active ? 'active' : '']">
                    {{ item.name }}
                </div>
            </div>
            <MoonPrice :fee="monthfee" v-if="tab.active == 'moon'"></MoonPrice>
            <YearPrice v-if="tab.active == 'year'"></YearPrice>
        </div> -->
        <div class="additional-services">
            <div class="title">附加服务</div>
            <div class="main">
                <div class="list">
                    <div class="items" v-for="(item, index) in fujiaList" :key="index">
                        <div class="name">{{ item.title }}</div>
                        <div class="tips">{{ item.detail }}</div>
                    </div>
                </div>
                <router-link to="/consultation">
                    <div class="buy">免费咨询</div>
                </router-link>

            </div>
        </div>
        <div class="common-problem">
            <div class="title">常见问题</div>
            <div class="main">
                <CommonProblem :list="problemList"></CommonProblem>
                <router-link to="/faq">
                    <div class="more">更多</div>
                </router-link>
            </div>
        </div>
        <Start></Start>

    </div>
</template>
<script>
import Start from '@/components/Start.vue'
import CommonProblem from '@/components/CommonProblem.vue'
import YearPrice from './components/YearPrice.vue'
import MoonPrice from './components/MoonPrice.vue'
export default {
    components: { Start, CommonProblem, YearPrice, MoonPrice },
    data() {
        return {
            monthfee: [498, 1288, 1888],
            fujiaList: [],
            problemList: [],
            services: [
                { title: '仍然是新手电商？', content: 'LOOPSHOP提供开店讲座及开店咨询服务，帮你打好基础，开店直播即赚！' },
                { title: '我已有网域，如何套用到LOOPSHOP继续使用？', content: '详情请与我们联络作进一步了解。' },
                { title: '如何为网店增加人气？', content: '商家可透过 LOOPSHOP KOL配对系统搜索合适的注册KOL，并即时联络 KOL 商讨合作销售，为网店增加人气！而直接对接KOL亦能免除媒体代理商的额外费用，减低营运成本。' },
            ],
            tab: {
                active: 'moon',
                list: [
                    { name: '月费计划', id: 'moon' },
                    { name: '年费计划', id: 'year' },
                ]
            },
            topList: {
                'moon': {
                    name: '爆单电商计划',
                    price: 'HK$ 888',
                    unit: '/月 (月缴)',
                    list: [
                        { title: '影片主导网店' },
                        { title: '自建可购式短片' },
                        { title: '自建可购式直播', tips: '包30,000分钟, 每额外6,000分钟为HK$120' },
                        { title: '同步直播至社交平台', tips: 'Facebook, Youtube' },
                        { title: '自建商城' },
                        { title: '自动化物流智能系统' },
                        { title: '12 种电子收款方式', append: '*' },
                        { title: '自订网域' },
                    ],
                    rightList: [
                        { title: 'KOL配对爆单引擎' },
                        { title: 'KOL分销秘密工具' },
                    ]
                },
                'year': {
                    name: '爆单电商计划',
                    price: 'HK$ 1500',
                    unit: '/月 (年缴)',
                    oldPrice: 'HK$ 1288',
                    oldUnit: '/月 (月缴)',
                    list: [
                        { title: '影片主导网店' },
                        { title: '自建可购式短片' },
                        { title: '自建可购式直播', tips: '包30,000分钟, 每额外6,000分钟为HK$120' },
                        { title: '同步直播至社交平台', tips: 'Facebook, Youtube' },
                        { title: '自建商城' },
                        { title: '自动化物流智能系统' },
                        { title: '12 种电子收款方式', append: '*' },
                        { title: '自订网域' },
                    ],
                    rightList: [
                        { title: 'KOL配对爆单引擎' },
                        { title: 'KOL分销秘密工具' },
                    ]
                }
            },
            list: {
                'moon': [
                    {
                        name: '精选电商计划',
                        price: 'HK$ 498',
                        list: [
                            { title: '自建可购式短片' },
                            { title: '自建可购式直播' },
                            { title: '超正影片主导网店主页' },
                            { title: '免费LOOPSHOP网域' },
                            { title: '可自行设计主页' },
                            { title: '超易手机一键直播' },
                            { title: '独家执货专员系统' },
                            { title: '简易推广优惠设定' },
                            { title: '超强数据分析' },
                            { title: '轻松同步直播至社交平台' },
                            { title: '收款方式 多达13种' },
                        ]
                    },
                    {
                        name: '专业电商计划',
                        price: 'HK$ 1288',
                        list: [
                            { title: '自订网域' },
                            { title: '自建产品商城' },
                            { title: '自动化物流智能系统' },
                        ],
                        moreList: [
                            { title: '自建可购式短片' },
                            { title: '自建可购式直播' },
                            { title: '超正影片主导网店主页' },
                            { title: '免费LOOPSHOP网域' },
                            { title: '可自行设计主页' },
                            { title: '超易手机一键直播' },
                            { title: '独家执货专员系统' },
                            { title: '简易推广优惠设定' },
                            { title: '超强数据分析' },
                            { title: '轻松同步直播至社交平台' },
                            { title: '收款方式 多达13种' },
                        ]
                    },
                    {
                        name: '全方位电商计划',
                        price: 'HK$ 1888',
                        list: [
                            { title: '全港首创KOL配对爆单引擎' },
                            { title: '全港首创KOL分销秘密武器' },
                        ],
                        moreList: [
                            { title: '自建可购式短片' },
                            { title: '自建可购式直播' },
                            { title: '超正影片主导网店主页' },
                            { title: '免费LOOPSHOP网域' },
                            { title: '自订网域' },
                            { title: '自建产品商城' },
                            { title: '自动化物流智能系统' },
                            { title: '可自行设计主页' },
                            { title: '超易手机一键直播' },
                            { title: '独家执货专员系统' },
                            { title: '简易推广优惠设定' },
                            { title: '超强数据分析' },
                            { title: '轻松同步直播至社交平台' },
                            { title: '收款方式 多达13种' },
                        ]
                    },
                ],
                'year': [
                    {
                        name: '精选电商计划',
                        price: 'HK$ 198',
                        oldPrice: 'HK$498',
                        list: [
                            { title: '自建可购式短片' },
                            { title: '自建可购式直播' },
                            { title: '超正影片主导网店主页' },
                            { title: '免费LOOPSHOP网域' },
                            { title: '可自行设计主页' },
                            { title: '超易手机一键直播' },
                            { title: '独家执货专员系统' },
                            { title: '简易推广优惠设定' },
                            { title: '超强数据分析' },
                            { title: '轻松同步直播至社交平台' },
                            { title: '收款方式 多达13种' },
                        ]
                    },
                    {
                        name: '专业电商计划',
                        price: 'HK$ 988',
                        oldPrice: 'HK$1288',
                        list: [
                            { title: '自订网域' },
                            { title: '自建产品商城' },
                            { title: '自动化物流智能系统' },
                        ],
                        moreList: [
                            { title: '自建可购式短片' },
                            { title: '自建可购式直播' },
                            { title: '超正影片主导网店主页' },
                            { title: '免费LOOPSHOP网域' },
                            { title: '可自行设计主页' },
                            { title: '超易手机一键直播' },
                            { title: '独家执货专员系统' },
                            { title: '简易推广优惠设定' },
                            { title: '超强数据分析' },
                            { title: '轻松同步直播至社交平台' },
                            { title: '收款方式 多达13种' },
                        ]
                    },
                    {
                        name: '全方位电商计划',
                        price: 'HK$ 1588',
                        oldPrice: 'HK$1888',
                        list: [
                            { title: '全港首创KOL配对爆单引擎' },
                            { title: '全港首创KOL分销秘密武器' },
                        ],
                        moreList: [
                            { title: '自建可购式短片' },
                            { title: '自建可购式直播' },
                            { title: '超正影片主导网店主页' },
                            { title: '免费LOOPSHOP网域' },
                            { title: '自订网域' },
                            { title: '自建产品商城' },
                            { title: '自动化物流智能系统' },
                            { title: '可自行设计主页' },
                            { title: '超易手机一键直播' },
                            { title: '独家执货专员系统' },
                            { title: '简易推广优惠设定' },
                            { title: '超强数据分析' },
                            { title: '轻松同步直播至社交平台' },
                            { title: '收款方式 多达13种' },
                        ]
                    },
                ]
            }
        }
    },

    created() {

        this.partner_id = this.$getStorage('partner_id')
        if (!this.partner_id) {
            if (this.$route.query.partner_id) {
                this.partner_id = this.$route.query.partner_id
                this.$setStorage('partner_id', this.partner_id)
            }
        } else {
            console.log('partner_id:', this.partner_id)
        }

    },

    mounted() {
        this.getList()
        this.getfujiaList()
    },
    methods: {
        openItem(val) {
            val.open = !val.open
        },

        async getList() {
            let fdata = { do: 'json', sjk: 'problemlist', limit: 3, searchkey: 'jingxuan', searchvalue: 1 }
            let res = await this.$api.funk(fdata)
            this.problemList = res
        },


        async getfujiaList() {
            let fdata = { do: 'json', sjk: 'fujialist', limit: 13 }
            let res = await this.$api.funk(fdata)
            this.fujiaList = res
        },

    }


}
</script>
<style lang="scss" scoped>
.plan-wrapper {

    .icon-list {
        width: 11.4rem;
        margin: 0 auto;
        margin-top: 0.4rem;

        .right {
            flex: 1;

            img {
                width: 0.72rem;
                height: 0.4rem;
                margin-right: 0.06rem;
                display: block;

                &:last-child {
                    margin-right: 0;
                }
            }
        }

        .left {
            .icon {
                width: 0.24rem;
                height: 0.24rem;
                margin-right: 0.1rem;
            }

            .text {
                .name {
                    color: var(--black-100, #000);
                    font-family: Microsoft YaHei;
                    font-size: 0.16rem;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;

                    span {
                        color: #B22535;
                    }
                }

                .sm-tip {
                    color: #000;
                    font-family: Microsoft YaHei;
                    font-size: 0.12rem;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                }
            }
        }
    }

    .plan-box {
        margin-top: 0.24rem;

        .sm-tips {
            width: 0.24rem;
            height: 0.24rem;
            cursor: pointer;
            position: relative;

            &:hover {
                p {
                    opacity: 1;
                }
            }

            img {
                width: 100%;
                height: 100%;
                display: block;
            }

            p {
                border-radius: 0.08rem;
                background: var(--blue-20, #D6F6F6);
                padding: 0.04rem 0.08rem;
                color: var(--black-100, #000);
                font-family: Microsoft YaHei;
                font-size: 0.14rem;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                position: absolute;
                left: 0.3rem;
                top: 0;
                bottom: 0;
                margin: auto 0;
                opacity: 0;
                transition: all .6s;
                min-height: 0.5rem;
                min-width: 2rem;
            }
        }


        .items {
            width: 5.4rem;
            height: 9.47rem;
            border-radius: 0.24rem;
            background: #FFF;
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
            margin: 0 0.2rem;
            padding: 0 0.4rem;
            padding-top: 0.88rem;

            .old-price {
                text-align: center;
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.34rem;
                color: #808080;
                transform: translateY(0.2rem);
                text-decoration: line-through;

                span {
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.24rem;
                    line-height: 0.24rem;
                    color: #808080;
                }
            }

            &.active {
                overflow: hidden;
                border: 1px solid #E02E43;
                padding: 0;
            }

            .bottom-img {
                width: 5.4rem;
                height: 3.44rem;
                margin-top: 0.4rem;
            }

            .padding-4 {
                padding: 0 0.4rem;
            }

            .top-title {
                width: 100%;
                height: 0.56rem;
                text-align: center;
                color: #FFF;
                font-family: Microsoft YaHei;
                font-size: 0.24rem;
                font-style: normal;
                font-weight: 600;
                line-height: 0.56rem;
                letter-spacing: 0.012rem;
                background: #E02E43;
            }

            .top-name {
                color: var(--black-100, #000);
                text-align: center;
                font-family: Microsoft YaHei;
                font-size: 0.4rem;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                margin-top: 0.32rem;
            }

            .top-tips {
                color: #000;
                text-align: center;
                font-family: Microsoft YaHei;
                font-size: 0.24rem;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                width: 3.8rem;
                margin: 0 auto;
                margin-top: 0.4rem;

            }


            .top {

                .name {
                    color: var(--black-100, #000);
                    text-align: center;
                    font-family: Microsoft YaHei;
                    font-size: 0.4rem;
                    font-style: normal;
                    font-weight: 600;
                    line-height: normal;
                }

                .price {
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 0.4rem;
                    line-height: 0.4rem;
                    color: #000000;
                    align-items: flex-end;
                    margin-top: 0.8rem;

                    &.active {
                        margin-top: 0.38rem;
                    }

                    span {
                        font-family: 'Microsoft YaHei';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 0.24rem;
                        line-height: 0.24rem;
                        color: #000000;
                    }
                }


            }

            .buy {
                width: 2.56rem;
                height: 0.64rem;
                margin: 0 auto;
                margin-top: 0.24rem;
                border-radius: 0.08rem;
                text-align: center;
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 600;
                font-size: 0.24rem;
                line-height: 0.64rem;
                border: 1px solid #E02E43;
                color: #E02E43;
                cursor: pointer;

                &.active {
                    background: #E02E43;
                    color: #ffffff;
                }
            }

            .list {
                margin-top: 0.4rem;
                border-top: 1px solid #000000;
                padding-top: 0.4rem;

                &.none {
                    border: none;
                    padding: 0;
                    margin-top: 0.2rem;
                }

                .small-title {
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 0.32rem;
                    line-height: 0.32rem;
                    color: #000000;
                    margin-bottom: 0.36rem;
                }


                .child {
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.24rem;
                    line-height: 0.24rem;
                    color: #000000;
                    height: 0.24rem;
                    margin-bottom: 0.26rem;

                    &.active {
                        font-weight: bold;
                    }

                    &:last-child {
                        margin-bottom: 0px;
                    }

                    span {
                        color: #B22535;
                    }

                    .icon {
                        width: 0.2rem;
                        height: 0.2rem;
                        display: block;
                        margin-right: 0.16rem;
                    }
                }
            }
        }
    }

    .tab {
        width: 2.9rem;
        height: 0.64rem;
        background: #D6F6F6;
        border-radius: 0.16rem;
        padding: 0.1rem;
        margin: 0 auto;
        margin-top: 0.24rem;

        .items {
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 400;
            font-size: 0.2rem;
            line-height: 0.42rem;
            width: 1.28rem;
            height: 100%;
            color: #000000;
            text-align: center;
            cursor: pointer;

            &.active {
                background: #ffffff;
                border-radius: 0.06rem;
            }
        }
    }

    .common-problem {
        padding-top: 0.96rem;

        .title {
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 600;
            font-size: 0.4rem;
            line-height: 0.56rem;
            color: #000000;
            text-align: center;
            margin-bottom: 0.5rem;

        }

        .more {
            width: 2.08rem;
            height: 0.64rem;
            border: 1px solid #E02E43;
            border-radius: 0.08rem;
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 600;
            font-size: 0.24rem;
            line-height: 0.64rem;
            text-align: center;
            color: #E02E43;
            margin: 0.8rem auto;
            cursor: pointer;
        }


    }

    .additional-services {
        width: 100%;
        padding-top: 0.72rem;
        // background: rgba(11, 217, 213, 0.1);
        background: var(--red-5, #F9EDEE);
        padding-bottom: 0.8rem;

        .title {
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 600;
            font-size: 0.4rem;
            line-height: 0.56rem;
            color: #000000;
            text-align: center;
        }

        .buy {
            width: 2.72rem;
            height: 0.8rem;
            background: #E02E43;
            border-radius: 0.08rem;
            margin: 0 auto;
            margin-top: 0.18rem;
            text-align: center;
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 600;
            font-size: 0.24rem;
            line-height: 0.8rem;
            color: #FFFFFF;
            cursor: pointer;
        }

        .list {
            margin-top: 0.4rem;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .items {
                width: 6.2rem;
                background: #FFFFFF;
                box-shadow: 0px 0.04rem 0.08rem rgba(0, 0, 0, 0.25);
                border-radius: 0.16rem;
                padding: 0.32rem 0.24rem;
                margin-bottom: 0.4rem;

                .name {
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.24rem;
                    line-height: 0.34rem;
                    color: #000000;
                }

                .tips {
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.16rem;
                    line-height: 0.22rem;
                    color: #000000;
                    margin-top: 0.08rem;
                }
            }
        }
    }

    .price-content {
        width: 100%;
        position: relative;
        padding: 0.8rem 0;



        img {
            width: 100%;
            display: block;
        }

        .button-1 {
            width: 2.56rem;
            height: 0.64rem;
            border-radius: 0.08rem;
            position: absolute;
            bottom: 1.2rem;
            left: 6.7rem;
            cursor: pointer;

            &.button-2 {
                bottom: 1.2rem;
                left: 9.98rem;
            }

            &.button-3 {
                bottom: 1.2rem;
                left: 13.2rem;
            }
        }

    }

    .content {
        background: rgba(255, 255, 255, 0.9);
        width: 100%;
        padding-top: 0.8rem;
        padding-bottom: 1.27rem;
        background: url('~@/assets/images/plan-bg.png')no-repeat center center /100% 100%;

        .title {
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 600;
            font-size: 0.64rem;
            line-height: 0.9rem;
            text-align: center;
            color: #000000;
        }

        .plan-list {
            width: 100%;
            margin-top: 0.46rem;
            align-items: flex-end;

            .items {
                width: 4rem;
                height: 11rem;
                background: #FFFFFF;
                box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
                border-radius: 0.24rem;
                padding: 0.4rem;
                position: relative;

                .name {
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 0.24rem;
                    line-height: 0.34rem;
                    text-align: center;
                    color: #000000;
                    text-align: center;
                }

                .tips {
                    margin-top: 0.16rem;
                    text-align: center;
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.16rem;
                    line-height: 0.22rem;
                    text-align: center;
                    color: #000000;
                }

                .old-price {
                    text-align: center;
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.24rem;
                    line-height: 0.34rem;
                    color: #808080;
                    transform: translateY(0.5rem);
                    text-decoration: line-through;
                }

                .price {
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 0.4rem;
                    line-height: 0.4rem;
                    color: #000000;
                    align-items: flex-end;
                    margin-top: 0.6rem;

                    span {
                        font-family: 'Microsoft YaHei';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 0.24rem;
                        line-height: 0.24rem;
                        color: #000000;
                    }
                }

                .buy {
                    width: 2.56rem;
                    height: 0.64rem;
                    margin: 0 auto;
                    margin-top: 0.24rem;
                    border-radius: 0.08rem;
                    text-align: center;
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 0.24rem;
                    line-height: 0.64rem;
                    border: 1px solid #E02E43;
                    color: #E02E43;
                    cursor: pointer;
                }

                .list {
                    margin-top: 0.4rem;
                    border-top: 1px solid #000000;
                    padding-top: 0.4rem;

                    &.none {
                        border: none;
                        padding: 0;
                        margin-top: 0.2rem;
                    }

                    .small-title {
                        font-family: 'Microsoft YaHei';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 0.16rem;
                        line-height: 0.22rem;
                        color: #000000;
                        margin-bottom: 0.16rem;
                    }


                    .child {
                        font-family: 'Microsoft YaHei';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 0.16rem;
                        line-height: 0.16rem;
                        color: #000000;
                        height: 0.22rem;
                        margin-bottom: 0.16rem;

                        &:last-child {
                            margin-bottom: 0px;
                        }

                        .icon {
                            width: 0.2rem;
                            height: 0.2rem;
                            display: block;
                            margin-right: 0.16rem;
                        }
                    }
                }

                .top {
                    display: none;
                }

                &.active {
                    height: 7.36rem;
                    padding-top: 0.96rem;

                    .top {
                        display: block;
                        width: 100%;
                        height: 0.56rem;
                        text-align: center;
                        background: #E02E43;
                        border-radius: 0.24rem 0.24rem 0px 0px;
                        font-family: 'Microsoft YaHei';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 0.16rem;
                        line-height: 0.56rem;
                        letter-spacing: 0.05em;
                        color: #FFFFFF;
                        position: absolute;
                        top: 0;
                        left: 0;

                    }

                    .buy {
                        background: #E02E43;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
}

@media (max-width: 750px) {
    .plan-wrapper .content .plan-list {
        display: block;
    }

    .plan-wrapper .content .plan-list .items {
        width: 100%;
        height: auto;
        margin-bottom: 0.4rem;
    }

    .plan-wrapper .content .plan-list .items .name {
        font-size: 0.4rem;
        line-height: 0.4rem;
        text-align: left;
    }

    .plan-wrapper .content .plan-list .items .old-price {
        font-size: 0.3rem;
        line-height: 0.3rem;
        text-align: left;
    }

    .plan-wrapper .content .plan-list .items .price {
        text-align: left;
        width: 100%;
        justify-content: flex-start;
    }

    .plan-wrapper .content .plan-list .items .buy {
        margin-left: 0;
    }

    .plan-wrapper .content .plan-list .items .list .small-title {
        font-size: 0.4rem;
        line-height: 0.4rem;
        margin-bottom: 0.4rem;
        margin-top: 0.3rem;
    }

    .plan-wrapper .content .plan-list .items .list .child {
        font-size: 0.3rem;
        line-height: 0.3rem;
        margin-bottom: 0.3rem;
    }

    .plan-wrapper .content .plan-list .items .list .child .icon {
        width: 0.3rem;
        height: 0.3rem;
    }

    .plan-wrapper .additional-services .list .items {
        width: 100%;
    }

    .plan-wrapper .additional-services .list .items .tips {
        line-height: 0.3rem;
    }

    .plan-wrapper .plan-box {
        flex-wrap: wrap;
    }

    .plan-wrapper .plan-box .items {
        width: 100%;
    }

    .plan-wrapper .plan-box .items.active {
        margin-top: 0.24rem;
    }

    .plan-wrapper .icon-list {
        flex-wrap: wrap;

        .left {
            width: 100%;
        }
    }

    .plan-wrapper .icon-list {
        width: 100%;
    }

    .plan-wrapper .icon-list .right {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
        flex: auto;
        margin-top: 0.08rem;

        img {
            width: 1rem;
            height: auto;
            margin: 0;
            margin-bottom: 0.08rem;
        }
    }
}
</style>